import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/viacoin': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M384 32l-48 112h48v48h-68.5l-13.8 32h82.3v48h-102.8l-89.2 208-89.2-208h-102.8v-48h82.3l-13.8-32h-68.5v-48h48l-48-112h64l80.8 192h94.5l80.7-192h64zM192 336l27-64h-54z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/viacoin.js
// module id = 1076
// module chunks = 0